/** 分类摘要（最差 2s）：运动 / 交互 / 动力 三条 0~1 的横条，颜色随分值由黄到橙红。 */
import type { BehaviorSceneRow } from '@/apis/simulation';

const ITEMS: { key: 'motion' | 'interaction' | 'dynamics'; name: string }[] = [
  { key: 'motion', name: '运动' },
  { key: 'interaction', name: '交互' },
  { key: 'dynamics', name: '动力' },
];

const barColor = (v: number): string => (v >= 0.6 ? '#dc5a2a' : v >= 0.3 ? '#e8893a' : v > 0.05 ? '#c4a02c' : '#9ca3af');

export default function SummaryBars({
  summary,
  hasInteraction = true,
}: {
  summary: BehaviorSceneRow['summary'];
  /** 该场景有没有近距障碍物可比。没有时「交互」显示「—」（没有可比对象），不是 0.00（没有差异）。 */
  hasInteraction?: boolean;
}) {
  if (!summary || Object.keys(summary).length === 0) return <span className="bc-muted">数据不足</span>;
  return (
    <div className="bc-sumbars">
      {ITEMS.map(({ key, name }) => {
        if (key === 'interaction' && !hasInteraction) {
          return (
            <div className="bc-sumbar" key={key} title="没有近距（5 米内）障碍物可比较">
              <span className="bc-sumbar-name">{name}</span>
              <span className="bc-sumbar-track" />
              <span className="bc-sumbar-val">—</span>
            </div>
          );
        }
        const v = summary[key] ?? 0;
        return (
          <div className="bc-sumbar" key={key}>
            <span className="bc-sumbar-name">{name}</span>
            <span className="bc-sumbar-track">
              <span className="bc-sumbar-fill" style={{ width: `${Math.min(v, 1) * 100}%`, background: barColor(v) }} />
            </span>
            <span className="bc-sumbar-val">{v.toFixed(2)}</span>
          </div>
        );
      })}
    </div>
  );
}
